module.exports = __webpack_public_path__ + "img/cert23.d6aefc8c.png";